/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * agora/v1/workspace.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  CurrentUserOrganizationWorkspacesParams,
  DeleteWorkspace200,
  ListWorkspacesParams,
  RpcStatus,
  UpdateWorkspaceBody,
  V1CurrentUserOrganizationWorkspacesResponse,
  V1ListWorkspacesResponse,
  V1Workspace,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Lists all workspaces that the current user has access to within a specific organization.
 */
export const currentUserOrganizationWorkspaces = (
  organization: string,
  params?: CurrentUserOrganizationWorkspacesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserOrganizationWorkspacesResponse>> => {
  return axios.default.get(
    `/api/v1/me/organizations/${organization}/workspaces`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCurrentUserOrganizationWorkspacesQueryKey = (
  organization?: string,
  params?: CurrentUserOrganizationWorkspacesParams,
) => {
  return [
    `/api/v1/me/organizations/${organization}/workspaces`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCurrentUserOrganizationWorkspacesQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: CurrentUserOrganizationWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCurrentUserOrganizationWorkspacesQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>
  > = ({ signal }) =>
    currentUserOrganizationWorkspaces(organization, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserOrganizationWorkspacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>
>;
export type CurrentUserOrganizationWorkspacesQueryError = AxiosError<RpcStatus>;

export function useCurrentUserOrganizationWorkspaces<
  TData = Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | CurrentUserOrganizationWorkspacesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationWorkspaces<
  TData = Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: CurrentUserOrganizationWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUserOrganizationWorkspaces<
  TData = Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: CurrentUserOrganizationWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all workspaces that the current user has access to within a specific organization.
 */

export function useCurrentUserOrganizationWorkspaces<
  TData = Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: CurrentUserOrganizationWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof currentUserOrganizationWorkspaces>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserOrganizationWorkspacesQueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all workspaces in an organization.
 */
export const listWorkspaces = (
  organization: string,
  params?: ListWorkspacesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspacesResponse>> => {
  return axios.default.get(`/api/v1/organizations/${organization}/workspaces`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListWorkspacesQueryKey = (
  organization?: string,
  params?: ListWorkspacesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWorkspacesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaces>>,
    ListWorkspacesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaces>>,
        TError,
        TData,
        QueryKey,
        ListWorkspacesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspacesQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaces>>,
    QueryKey,
    ListWorkspacesParams['page_token']
  > = ({ signal, pageParam }) =>
    listWorkspaces(
      organization,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWorkspaces>>,
    TError,
    TData,
    QueryKey,
    ListWorkspacesParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspacesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaces>>
>;
export type ListWorkspacesInfiniteQueryError = AxiosError<RpcStatus>;

export function useListWorkspacesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaces>>,
    ListWorkspacesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListWorkspacesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaces>>,
        TError,
        TData,
        QueryKey,
        ListWorkspacesParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspacesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaces>>,
    ListWorkspacesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaces>>,
        TError,
        TData,
        QueryKey,
        ListWorkspacesParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspacesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaces>>,
    ListWorkspacesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaces>>,
        TError,
        TData,
        QueryKey,
        ListWorkspacesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all workspaces in an organization.
 */

export function useListWorkspacesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaces>>,
    ListWorkspacesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaces>>,
        TError,
        TData,
        QueryKey,
        ListWorkspacesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspacesInfiniteQueryOptions(
    organization,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListWorkspacesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspacesQueryKey(organization, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaces>>> = ({
    signal,
  }) => listWorkspaces(organization, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaces>>
>;
export type ListWorkspacesQueryError = AxiosError<RpcStatus>;

export function useListWorkspaces<
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListWorkspacesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaces<
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaces<
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all workspaces in an organization.
 */

export function useListWorkspaces<
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListWorkspacesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspacesQueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new workspace within an organization.
 */
export const createWorkspace = (
  organization: string,
  v1Workspace: NonReadonly<V1Workspace>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Workspace>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces`,
    v1Workspace,
    options,
  );
};

export const getCreateWorkspaceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspace>>,
    TError,
    { organization: string; data: NonReadonly<V1Workspace> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkspace>>,
  TError,
  { organization: string; data: NonReadonly<V1Workspace> },
  TContext
> => {
  const mutationKey = ['createWorkspace'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkspace>>,
    { organization: string; data: NonReadonly<V1Workspace> }
  > = props => {
    const { organization, data } = props ?? {};

    return createWorkspace(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspace>>
>;
export type CreateWorkspaceMutationBody = NonReadonly<V1Workspace>;
export type CreateWorkspaceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new workspace within an organization.
 */
export const useCreateWorkspace = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWorkspace>>,
      TError,
      { organization: string; data: NonReadonly<V1Workspace> },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createWorkspace>>,
  TError,
  { organization: string; data: NonReadonly<V1Workspace> },
  TContext
> => {
  const mutationOptions = getCreateWorkspaceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets details of a specific workspace.
 */
export const getWorkspace = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Workspace>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}`,
    options,
  );
};

export const getGetWorkspaceQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}`,
  ] as const;
};

export const getGetWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceQueryKey(organization, workspace);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspace>>> = ({
    signal,
  }) => getWorkspace(organization, workspace, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspace>>
>;
export type GetWorkspaceQueryError = AxiosError<RpcStatus>;

export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getWorkspace>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getWorkspace>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets details of a specific workspace.
 */

export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkspaceQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a workspace.
 */
export const deleteWorkspace = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteWorkspace200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}`,
    options,
  );
};

export const getDeleteWorkspaceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspace>>,
    TError,
    { organization: string; workspace: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkspace>>,
  TError,
  { organization: string; workspace: string },
  TContext
> => {
  const mutationKey = ['deleteWorkspace'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkspace>>,
    { organization: string; workspace: string }
  > = props => {
    const { organization, workspace } = props ?? {};

    return deleteWorkspace(organization, workspace, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspace>>
>;

export type DeleteWorkspaceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes a workspace.
 */
export const useDeleteWorkspace = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteWorkspace>>,
      TError,
      { organization: string; workspace: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkspace>>,
  TError,
  { organization: string; workspace: string },
  TContext
> => {
  const mutationOptions = getDeleteWorkspaceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an existing workspace.
 */
export const updateWorkspace = (
  organization: string,
  workspace: string,
  updateWorkspaceBody: NonReadonly<UpdateWorkspaceBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Workspace>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}`,
    updateWorkspaceBody,
    options,
  );
};

export const getUpdateWorkspaceMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspace>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<UpdateWorkspaceBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspace>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<UpdateWorkspaceBody>;
  },
  TContext
> => {
  const mutationKey = ['updateWorkspace'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspace>>,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<UpdateWorkspaceBody>;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return updateWorkspace(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkspace>>
>;
export type UpdateWorkspaceMutationBody = NonReadonly<UpdateWorkspaceBody>;
export type UpdateWorkspaceMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an existing workspace.
 */
export const useUpdateWorkspace = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWorkspace>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: NonReadonly<UpdateWorkspaceBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspace>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<UpdateWorkspaceBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateWorkspaceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
